
export const status = [
  { value: 'ACTIVE' },
  { value: 'INACTIVE' },
];

